import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import ServicesApiService from '@/modules/settings/services/ServicesApiService';
import {Tag} from 'antd';
import {map} from 'lodash';
import {useGetAllServices} from '@/modules/auditorAudits/hooks/useAuditorAudits';
import {TermFilter} from '@dofleini/query-builder';

const SelectUserServices = ({value, onChange, translation, spaceId, ...props}) => {

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v?._id || v) : undefined;
  }, [value]);

  return (
    <SelectElementCmp
      queryKey={'user-services'}
      service={ServicesApiService}
      // filters={filters}
      customMethod={`/ms-core/api/spaces/${spaceId}/services`}
      value={currentValue}
      onChange={onChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      placeholder={translation('placeholderSelectServices')}
      nameToShow={'name'}
      mode={'multiple'}
      additionalParams={{
        forceSize: true,
        size: 1000,
        useProjections: true,
        projections: {
          name: 1
        }
      }}
      {...props}
    />
  );
};

SelectUserServices.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isViewMode: PropTypes.func,
  translation: PropTypes.func,
  defaultValue: PropTypes.array,
  spaceId: PropTypes.string,
};

// eslint-disable-next-line no-unused-vars
const SelectUserServicesView = ({value, entity}) => {
  const filter = useMemo(() => {
    return new TermFilter({field: '_id', value: { $in: value } }).toQuery();
  }, [value]);
  
  const {data} = useGetAllServices(filter);

  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={`tag-${item['_id']}`} className="pb-2">
          <Tag className="px-2 py-1">
            {item['name']}
          </Tag>
        </div>
      ))}
    </div>);
  }, []);

  return (
    <>
      {tagsRender(data|| [])}
    </>
  );
};

SelectUserServicesView.propTypes = {
  value: PropTypes.string,
  entity: PropTypes.object,
};

export default memo(SelectUserServices);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderTemplateService = (text, entity) => {
  return (
    <SelectUserServicesView value={text} entity={entity}/>
  );
};

